import { FC, PropsWithChildren } from 'react'
import { SettingButton } from '../../atoms/SettingButton'
import styles from './index.module.scss'

type Props = {
  buttonHref?: string
  buttonLabel?: string
  buttonTarget?: string
}

export const SettingsContentHeader: FC<PropsWithChildren<Props>> = ({
  children,
  buttonHref = '',
  buttonLabel = 'Preview',
  buttonTarget = null,
}) => {
  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>{children}</h1>
      {buttonHref && (
        <div className={styles.btn}>
          <SettingButton href={buttonHref} color='white' componentType='a' target={buttonTarget}>
            {buttonLabel}
          </SettingButton>
        </div>
      )}
    </div>
  )
}
